import React from "react"
import { Link } from "gatsby"
import Seo from "../components/seo"
import Layout from "../components/layout"
import Nav from "../components/nav"

import Banner from "../images/sparkle-business-vas-banner.png"
import TaxIdentification from "../images/tax-identification.png"
import BusinessOnboarding from "../images/business-onboarding.png"
import CompanyIncorporation from "../images/company-incorporation.png"

const Index = () => {
  return (
    <Layout downloadFooter="false">
      <Seo
        title="Business support and value added services from Sparkle"
        desc="Sparkle offers business support solutions as part of our value added services, helping business owners efficiently get their CAC, TIN and other business certifications"
      />
      <div className="sparklevas">
        <div className="nav-wrapper bg__sparkle--black">
          <div className="container">
            <Nav />
          </div>
        </div>

        <div className="container">
          <div className="row align-center py-5">
            <div className="col-lg-6 mt-5">
              <h1 className="sparkle--font__56 hero__title text-dark">
                Register your business, Get Your TIN. Do both with Sparkle
              </h1>
              <div className="">
                <p className="mt-4 hero__description text-dark">
                  Every business needs a registered business name and Tax
                  Identification number (TIN) to operate. We can help you get
                  both, all on your mobile phone.​
                </p>

                <Link
                  to="/business-support/"
                  className="btn sparkle--button__green px-5 mt-4"
                >
                  Get Started
                </Link>
              </div>
            </div>

            <div className="col-lg-6 order-first order-lg-last text-center">
              <img
                src={Banner}
                alt="Business support and value added services from Sparkle"
                title="Business support and value added services from Sparkle"
                className="img-fluid"
              />
            </div>
          </div>
        </div>

        <section className="py-lg-5" style={{ backgroundColor: "#EEEEEE" }}>
          <div className="container py-lg-5 my-lg-5">
            <div className="row align-center py-5">
              <div className="col-lg-5 my-3">
                <h1 className="sparkle--font__56 hero__title text-dark">
                  Get Your Business Registered!
                </h1>
                <div className="">
                  <p className="mt-4 hero__description text-dark">
                    Make your business official, register your business name
                    from the comfort of your home and get your Corporate Affairs
                    Commission (CAC) document delivered to your doorstep. ​
                  </p>
                </div>
              </div>

              <div className="col-lg-4 offset-lg-2 order-first order-lg-last my-3 text-center">
                <img
                  src={CompanyIncorporation}
                  alt="Business support and value added services from Sparkle"
                  title="Business support and value added services from Sparkle"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-lg-5" style={{ backgroundColor: "#F6F6F6" }}>
          <div className="container py-lg-5 my-lg-5">
            <div className="row align-center py-5">
              <div className="col-lg-5  my-4">
                <h1 className="sparkle--font__56 hero__title text-dark">
                  Get Your Tax Identification Number
                </h1>
                <div className="">
                  <p className="mt-4 hero__description text-dark">
                    To sign up to Sparkle business, you need your TIN for
                    validation and easy tax filing. With our business support
                    services, you can get your TIN directly from FIRS and edit
                    your business tax profile as you like. It cost just ₦5,000.​
                    ​
                    {/* <span className="style-1">
                      <del>
                        <span className="amount">₦4,000</span>
                      </del>
                      <ins>
                        <span className="amount">₦2,500</span>
                      </ins>
                    </span> */}
                    (valid for first 100 businesses).
                  </p>
                </div>
              </div>

              <div className="col-lg-4 offset-lg-2 order-first order-lg-last my-4 text-center">
                <img
                  src={TaxIdentification}
                  alt="Sparkle offers business owners who don’t have a TIN to be able to get one from FIRS as well as make edits or correction to your business Tax profile."
                  title="Sparkle offers business owners who don’t have a TIN to be able to get one from FIRS as well as make edits or correction to your business Tax profile."
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-lg-5" style={{ backgroundColor: "#F2F2F2" }}>
          <div className="container my-lg-5 py-lg-5">
            <div className="row align-center py-5">
              <div className="col-lg-5 order-last offset-lg-2 my-4">
                <h1 className="sparkle--font__56 hero__title text-dark text-lg-right">
                  Get Onboard Sparkle Business
                </h1>
                <div className="">
                  <p className="mt-4 hero__description text-dark text-lg-right">
                    Now that you have registered your business and gotten your
                    Tax Identification Number, you can now sign up to Sparkle
                    Business and watch your business sparkle.​
                  </p>
                </div>
              </div>

              <div className="col-lg-4 my-4 text-center">
                <img
                  src={BusinessOnboarding}
                  alt="Business support and value added services from Sparkle"
                  title="Business support and value added services from Sparkle"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}

export default Index
